export const STATE = 'audio'

export const SET_AUDIO_MUSIC = `${STATE}/SET_AUDIO_MUSIC`
export const SET_SCROLL_ACTIVE_AUDIO = `${STATE}/SET_SCROLL_ACTIVE_AUDIO`
